import { PropType, defineComponent, ref } from 'vue'

import { CsCopyTextLink } from '@sunrise/components'

import { DecoratedContactDetails } from '../../ts/mapper/decoratedEstateDetailMapper.interface'

import { ContactBtnPosition } from '../MsDetailContactBtnGroup/MsDetailContactBtnGroup.enum'
import MsDetailContactBtnGroup from '../MsDetailContactBtnGroup/MsDetailContactBtnGroup.vue'
import { ContactNumberType } from '../MsDetailModalCall/MsDetailModalCall.enum'
import MsDetailModalImprint from '../MsDetailModalImprint/MsDetailModalImprint.vue'

export default defineComponent({
    name: 'MsDetailContactInfo',
    components: {
        MsDetailContactBtnGroup,
        CsCopyTextLink,
        ContactBtnPosition,
        MsDetailModalImprint,
    },
    props: {
        contact: {
            type: Object as PropType<DecoratedContactDetails>,
            required: true,
        },
        position: {
            type: String as PropType<ContactBtnPosition>,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
        componentId: {
            type: String,
            required: true,
        },
    },

    setup() {
        const imprintModalIsVisible = ref<boolean>(false)

        function openImprintModal() {
            imprintModalIsVisible.value = true
        }

        function closeImprintModal() {
            imprintModalIsVisible.value = false
        }

        function determineNumberLabel(label: string): string | undefined {
            switch (label) {
                case ContactNumberType.PHONENUMBER:
                    return 'Telefonisch (Festnetz):'
                case ContactNumberType.MOBILENUMBER:
                    return 'Telefonisch (Mobil):'
                case ContactNumberType.FAXNUMBER:
                    return 'Fax:'
            }
        }

        return {
            ContactBtnPosition,
            closeImprintModal,
            openImprintModal,
            imprintModalIsVisible,
            determineNumberLabel,
        }
    },
})
